import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { DEFAULT_DEXT_CHECKBOX_GROUP_OTHER_INPUT_LENGTH, FIELD_TYPES } from '../../../constants';
import { CheckboxGroupFieldWUT } from '../../../ui/checkbox-group-field';
export const DextCheckboxGroupWUT = props => {
  const fieldType = FIELD_TYPES.DEXT_CHECKBOX_GROUP;
  return /*#__PURE__*/React.createElement(CheckboxGroupFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    otherInputCharacterLimit: DEFAULT_DEXT_CHECKBOX_GROUP_OTHER_INPUT_LENGTH
  }));
};
//# sourceMappingURL=dext-checkbox-group-wut.js.map